// extracted by mini-css-extract-plugin
export default {"certain":"style_certain__NCFDQ"};